<template>
  <span v-if="!html" @click.stop="openReport">
    <a href="javascript:void(0);" :style="styleStr" :class="classname" v-if="isSafari" @click="aTagClick(href)" :rel="rel" target="_blank">
      <slot></slot>
    </a>
    <a :href="href" @click.prevent=" return aTagClick(href)" v-else target="_blank" :style="styleStr" :class="classname" :rel="rel">
      <slot></slot>
    </a>
  </span>
  <span v-else @click.stop="openReport">
    <a href="javascript:void(0);" :style="styleStr" :class="classname" v-if="isSafari" @click="aTagClick(href)" :rel="rel" v-html="html" target="_blank"></a>
    <a :href="href" @click.prevent=" return aTagClick(href)" v-else target="_blank" :style="styleStr" :class="classname" :rel="rel" v-html="html"></a>
  </span>
</template>
<script>
import { getPathParam } from '../../common/utils.js'
var isSafari;
var ua = navigator.userAgent.toLowerCase();
if (ua.indexOf('safari') != -1) {
  if (ua.indexOf('chrome') > -1) {
  } else {
    isSafari = true;
  }
}
export default {
  props: ['href', 'rel', 'html', 'classname', 'styleStr', 'from'],
  data () {
    return {
      isSafari: isSafari
    };
  },
  methods: {
    aTagClick (path) {
      if (__VERSION === 'HQ' ) {
        if (/https?|\./.test(path)) {
          parent.postMessage({ msg: path }, '*');
        }else{
          this.hrefJump(path,getPathParam('company', path))
        }
        // let host = window.location.host
        // let target = `https://ptest.hecom.cn/cusweb/dist/externalx.html?url=${encodeURI(host + path)}&title=${'蜂寻-' + getPathParam('company', path)}`
        // window.top.open(target, '_blank');
      } else {
        this.isDtAppLogin = !!this.getItem('session', 'isDtAppLogin');
        let openFlag = this.isDtAppLogin ? '_self' : '_blank';
        if (/https?|\./.test(path)) { //外面的地址
          window.open(path, openFlag,'noopener=yes,noreferrer=yes');
        } else { //自己的地址
          let Origin = this.getOrigin();
          window.open(Origin + path, openFlag);
        }
      }

    },
    openReport () {
      return 1;
    }
  },
};
</script>
<style lang="scss" scoped>
a {
  color: #555;

}
.hq-alink{
  a{
    color: #337ab7;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/global/gemLink.vue